<template>
    <!-- 上传附件 -->
    <div class="wk-input-date-slt wk-input-box" :style="styleCpt">
        <span class="input-left-label" v-if="labelOver">{{labelOver}}</span>
        <div class="posi-relative">
            <input-base :id="idOver" v-model="inputVal" classCpt="dateInput cur-pot" readonly  
                :placeholder="'请输入' + placeholderOver" :initVal="value" ref="inputRef"/>
            <img class="posi-absolute" style="z-index:-1" id='time_icon' src="../../assets/img/register-icon-10.png">
        </div>
    </div>
</template>
 
<script>
    export default {
        name: 'inputlsit',
        props: ['label','id','type','dtName','value','minDate','maxDate','placeholder','styleCpt'],
        mounted(){
            //label 
            this.label ? this.labelOver = this.label : '';
            //提示
            if(this.placeholder){
                this.placeholderOver =  this.placeholderOver + this.placeholder;
            }else if(this.label){
                this.placeholderOver =  this.placeholderOver + this.label;
            }
            // 如果是 预约交易日期,必须是下一个工作日
            if(this.type == 'hopeDate'){ 
                this.minDate ? this.initDate(this) : '';
            }else{
                this.initDate(this);
            } 
            // let that = this;
            //
            // $('#time_icon').click(function(){
            //     $(this).siblings('p').find('input').trigger("click");
            //     $(this).siblings('p').find('input').focus();
            // });
            this.idOver = this.id + "_" + this.num;
        },
        watch:{
            inputVal(){
                this.$emit('input',this.inputVal);
            },
            value(){
                this.$refs.inputRef.setValue(this.value)
                this.$emit('input',this.value);
            },
            minDate(){
                this.initDate(this);
            },
            maxDate(){
                this.initDate(this);
            }
        },
        data(){
            return{
                inputVal:'',
                isLangDate:false,
                labelOver:'',
                placeholderOver:'',
                idOver:'',
                num:1
            }
        },
        methods:{
            // 初始化日期
            initDate(that){
                let minDate = that.minDate ? that.minDate : '1900-01-01', maxDate = ''; 
                if(that.maxDate && that.maxDate.length >= 8){
                    maxDate = that.maxDate;
                }else{
                    maxDate = that.maxDate ? that.$tools.getDateNew(that.maxDate) : '9999-12-31';
                }
                this.num++;
                this.idOver = this.id + "_" + this.num;

                this.$nextTick(()=>{
                    laydate.render({
                        elem:'#' + that.idOver, //指定元素
                        showBottom: false,
                        // trigger: 'click', //触发方式，默认 focus
                        min: minDate,
                        max: maxDate,
                        value: that.$route.name.indexOf('assetProofInfo') > -1 ? maxDate : '',
                        done:function(value){ //选定日期或单击按钮后
                            that.inputVal = value;
                            that.$emit('input',value);
                            that.$refs.inputRef.setValue(value)
                        }	   
                    });
                })
            },
            setValue(val){
                this.inputVal = val;
                this.$refs.inputRef.setValue(val)
            }
        }
    }
</script>
<style lang="less" scoped>
    .wk-input-date-slt{
        margin:.9rem 0;
        >div{
            img{
                width:1rem;
                height:1rem;
                top:.55rem;
                right:.6rem;
            }
            >div{
                top:0;
                right:-5.5rem;
                width: 5.1rem;
                line-height: 2.1rem;
                padding:0 .5rem;
                border:.05rem solid #d1d1d1;
                color:#666;
                cursor: pointer;
                text-align: center;
                font-size:0.8rem; 
            }
        }
    }
</style>
<style lang="less">
    .wk-input-date-slt{
        >div{
            input[readonly='readonly']{
                background: transparent;
                background:url('../../assets/img/register-icon-10.png') no-repeat right;
                background-position: 97%;
            }
 
        }
    }   
</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/wkInputDateSlt.vue